import { AppSecurityRight } from './app.security';
import { JobSection, JobSectionVerb } from './job.section.rights';
import { PortalContractorSecurityRight } from './portal.contractors.security.module';

/** The portal's own section rights: subcontractors work under portal permissions, never the web Jobs ones. */
export const PortalContractorSectionRightIds: Record<JobSection, Record<JobSectionVerb, PortalContractorSecurityRight>> = {
    tasks: { view: PortalContractorSecurityRight.TasksView, create: PortalContractorSecurityRight.TasksCreate, edit: PortalContractorSecurityRight.TasksEdit, delete: PortalContractorSecurityRight.TasksDelete },
    items: { view: PortalContractorSecurityRight.ItemsView, create: PortalContractorSecurityRight.ItemsCreate, edit: PortalContractorSecurityRight.ItemsEdit, delete: PortalContractorSecurityRight.ItemsDelete },
    sors: { view: PortalContractorSecurityRight.SorsView, create: PortalContractorSecurityRight.SorsCreate, edit: PortalContractorSecurityRight.SorsEdit, delete: PortalContractorSecurityRight.SorsDelete },
};

/** Subcontractors never add or delete tasks in the portal, so the Tasks row offers View and Edit only. */
export const PORTAL_CONTRACTOR_TASK_VERBS: JobSectionVerb[] = ['view', 'edit'];

const { tasks, items, sors } = PortalContractorSectionRightIds;

/**
 * The new portal rights a role needs on release day to keep what it could do before they existed: jobs
 * access gave full contractor use of tasks, items and SORs (the status rules decided the rest), and every
 * portal login could open Allocations. Applied once per role — system roles in their class, custom roles by
 * the tenant upgrade — and never re-derived afterwards.
 */
export function portalContractorReleaseRights(rights: number[]): PortalContractorSecurityRight[] {

    const jobs = rights.includes(PortalContractorSecurityRight.CanAccessJobs)
        ? [tasks.view, tasks.edit, items.view, items.create, items.edit, items.delete, sors.view, sors.create, sors.edit, sors.delete]
        : [];
    const scheduler = rights.includes(AppSecurityRight.LoginContractor) ? [PortalContractorSecurityRight.AccessScheduler] : [];

    return [...jobs, ...scheduler];
}

/** A system role's rights plus its release-day portal rights, for the role classes. */
export function withPortalContractorReleaseRights(rights: number[]): number[] {

    return [...new Set([...rights, ...portalContractorReleaseRights(rights)])];
}
